import Api from '@/Scripts/api/api';
import { PRODUCTCODES, WAREHOUSECODES } from '@/Scripts/constants.js';

const getAPIKeyWord = (arr) => {
  if (arr.some(obj => obj.WarehouseCode === WAREHOUSECODES.WAREHOUSE_0040)) {
    if (arr.some(obj => obj.Code === PRODUCTCODES.ULYSSE) || arr.some(obj => obj.ProductCode === PRODUCTCODES.ULYSSE)) {
      return 'UlysseShipInfo';
    }
    return 'ShipFromOppdalInfo';
  }
  return '';
};

export default {
  data () {
    return {
      shippingMessage: '',
      shippingMessageCalled: false

    };
  },
  methods: {
    getShippingMsg (productArray) {
      if (!this.shippingMessageCalled) {
        const k = getAPIKeyWord(productArray);
        if (k) {
          this.shippingMessageCalled = true;
          Api.getContentByFriendlyUrl(`api/siteinfo/${k}`).then((response) => {
            if (response.data) {
              this.shippingMessage = response.data[k];
            }
          }).catch((error) => {
            if (error.response.status !== 404) {
              throw error;
            }
          });
        }
      }
    }
  }
};
